import { useStandardProductType } from "app/hooks/shared/standard-product/useStandardProductType";
import { useCartContext } from "app/providers/CartProvider";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

const CheckoutInfoHeader = () => {
  const cart = useCartContext().getCart();
  const isSampleSale = useCartContext().isSampleSale;
  const productAnalysis = useStandardProductType(cart);
  const containsZakelijkProducts = useCartContext().containsZakelijkProducts;

  const text =
    // If its door products
    cart.products.length > 0
      ? //if its not a sample sale
        !isSampleSale
        ? cart.isSelfAssembly
          ? containsZakelijkProducts
            ? //if its business doors
              "Gers dat jij een bestelling bij ons wilt plaatsen! Kijk de producten in je winkelmand nog één keer goed na en vul hieronder je gegevens in om de bestelling compleet te maken."
            : // if its self assembly
              "Gers! Jij gaat binnenkort je maatwerk deur zelf monteren. Kijk nog één keer je bestelling goed na en vul hieronder je gegevens goed in."
          : // normal door
            `Je bent bijna klaar om je gratis inmeetafspraak vast te leggen. Vul
        hieronder je gegevens in en check nogmaals de producten in je
        winkelwagen. Geen zorgen: je zit nog nergens aan vast! Wij zorgen alleen
        dat de inmeter voldoende tijd heeft om je te adviseren en om de
        producten op locatie in te meten.`
        : // if its a sample sale
          "Nu je je sample sale deur hebt gekozen, is het tijd om je gegevens in te vullen zodat we je bestelling op naam kunnen zetten. Check nog één keer goed welke deur(en) je aanschaft en vul onderstaande velden in."
      : // else if its std products
        cart.standardProducts.length > 0
        ? // if it contains acoustic panels
          productAnalysis.someAkoestischepanelen
          ? "Je bent bijna klaar met je bestelling. Vul hieronder je gegevens in en check nogmaals de " +
            "producten in je winkelwagen. Kom je de akoestische panelen zelf bij ons ophalen? Dan worden je " +
            "persoonsgegevens uitsluitend gebruikt voor op je factuur. "
          : // if it doesnt have acoustic panels, but glass/kleur
            "Je bent bijna klaar met je bestelling. Vul hieronder je adresgegevens in zodat we je bestelling snel naar je toe kunnen sturen."
        : "";

  return (
    <header className="gg-mb-12">
      <Heading headingLevel="h2" className="gg-mb-6 gg-text-2xl">
        Persoonlijke gegevens
      </Heading>
      <Text className="gg-mb-4">{text}</Text>
      <Text className="gg-text-dark-blue-500">
        Velden met een * zijn verplicht
      </Text>
    </header>
  );
};
export default CheckoutInfoHeader;
